import themeReducer from './themeReducer'
import sidebarReducer from './sidebarReducer'
import newOrderTableReducer from './newOrderTableReducer'
import userReducer from './userReducer'
import productReducers from './productReducers'
import cartReducer from './cartReducer'
import complianceReducer from './complianceReducer'
import stripeReducer from './stripeReducer'
import profileActivityReducer from './profileActivityReducer'
import apolloReducer from './apolloReducer'
import toggleTourReducer from './toggleTourReducer'

export {
  themeReducer,
  sidebarReducer,
  newOrderTableReducer,
  userReducer,
  productReducers,
  cartReducer,
  complianceReducer,
  stripeReducer,
  profileActivityReducer,
  apolloReducer,
  toggleTourReducer
}



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js